module.exports = __webpack_public_path__ + "static/media/flag-kz.4d6f3092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-kz.svg
// module id = 2385
// module chunks = 7